export default __webpack_public_path__ + "static/media/Liyna-Anwar.a7445d87.jpg";